import React, { useEffect } from 'react'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import { useCurrentSociety } from '../../../hooks/useCurrentSociety'
import { useSelectedSocietyId } from '../../../hooks/useSelectedSocietyContext'
import { reverseUrl } from '../../../navigation/reverseUrl'

const SocietyRoot = (): React.ReactNode => {
  const { setCurrentSocietyId, selectedSocietyId } = useSelectedSocietyId()
  const { society } = useCurrentSociety()

  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    setCurrentSocietyId(id)
  }, [id, setCurrentSocietyId])

  useEffect(() => {
    selectedSocietyId &&
      location.pathname === `/society/${id}` &&
      navigate(reverseUrl('society:home', { id }), {
        replace: true,
      })
  }, [id, location.pathname, navigate, selectedSocietyId])

  return <>{society && <Outlet />}</>
}

export { SocietyRoot }
